import { render } from "./ReservationPassengers.vue?vue&type=template&id=71ee6014"
import script from "./ReservationPassengers.vue?vue&type=script&lang=js"
export * from "./ReservationPassengers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__